export const logoFilled = "https://i.postimg.cc/pXvY7rcL/linkedin-logo.png";
export const logoUnFilled = "https://i.postimg.cc/WbfKP0B7/li.png";
export const profileImage =
    "https://images.unsplash.com/profile-1636314514258-92c5f3e86bd3?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&cs=tinysrgb&fit=crop&h=64&w=64";
